module.exports = __webpack_public_path__ + "media/img/frontend_application/banner/free-outside-sg/tab-f2016b16fe7c8f47f3a9aaa23f83bc06.png";